import React, { useState } from 'react';
import Modal from './Modal';

// Abbinamento fra partecipanti e rose importate (solo asta di riparazione).

export default function TeamAssignment({ participants, importedTeams, onAssign, onClose }) {
    const [assignments, setAssignments] = useState({});

    const assign = (participantId, teamName) => {
        setAssignments((current) => {
            const next = { ...current };
            Object.keys(next).forEach((key) => {
                if (next[key] === teamName) delete next[key];
            });
            if (teamName) next[participantId] = teamName;
            else delete next[participantId];
            return next;
        });
    };

    const names = Object.keys(importedTeams ?? {});
    const taken = new Set(Object.values(assignments));
    const complete = Object.keys(assignments).length === participants.length;

    return (
        <Modal
            open
            title="Assegna le rose"
            onClose={onClose}
            footer={
                <>
                    <button type="button" className="btn btn--ghost" onClick={onClose}>
                        Chiudi
                    </button>
                    <button
                        type="button"
                        className="btn btn--primary"
                        disabled={!complete}
                        onClick={() => onAssign(assignments)}
                    >
                        Salva assegnazioni
                    </button>
                </>
            }
        >
            <div className="stack">
                {participants.map((participant) => {
                    const assigned = assignments[participant.id] ?? '';
                    return (
                        <div key={participant.id} className="field">
                            <label className="field-label">{participant.name}</label>
                            <select
                                className="select"
                                value={assigned}
                                onChange={(event) => assign(participant.id, event.target.value)}
                            >
                                <option value="">Scegli una squadra</option>
                                {names
                                    .filter((name) => !taken.has(name) || name === assigned)
                                    .map((name) => (
                                        <option key={name} value={name}>
                                            {name}
                                        </option>
                                    ))}
                            </select>
                        </div>
                    );
                })}
                {!complete && <p className="field-hint">Assegna una rosa a ogni partecipante.</p>}
            </div>
        </Modal>
    );
}
